import { createGlobalStyle } from 'styled-components';

export const EmbeddedPage = createGlobalStyle`
  header#plasma-ui-app-header {
    display: none;
  }
`;
